var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { inRange } from '../../utils/math';
var CartesianCoord = /** @class */ (function () {
    function CartesianCoord(xAxis, yAxis) {
        this.coordinateSystem = 'cartesian2d';
        this.dimensions = ['x', 'y'];
        this._xAxis = xAxis;
        this._yAxis = yAxis;
    }
    CartesianCoord.prototype.dataToCoord = function (data, indexMode) {
        var xScale = this._xAxis.scale;
        var yScale = this._yAxis.scale;
        var indexX = xScale.type === 'ordinal' && indexMode;
        var indexY = yScale.type === 'ordinal' && indexMode;
        var x = !indexX ? data.x : xScale.categories.indexOf(data.x);
        var y = !indexY ? data.y : yScale.categories.indexOf(data.y);
        return {
            x: xScale.scale(x),
            y: yScale.scale(y),
        };
    };
    CartesianCoord.prototype.coordToPoint = function (coord) {
        var _a = [this._xAxis.scale.start, this._xAxis.scale.end], startx = _a[0], endx = _a[1];
        var _b = [this._yAxis.scale.start, this._yAxis.scale.end], starty = _b[0], endy = _b[1];
        return __assign(__assign({}, coord), { outside: !(inRange(coord.x, [startx, endx]) && inRange(coord.y, [starty, endy])) });
    };
    CartesianCoord.prototype.dataToPoint = function (data, indexMode) {
        if (indexMode === void 0) { indexMode = false; }
        return this.coordToPoint(this.dataToCoord(data, indexMode));
    };
    CartesianCoord.prototype.pointToCoord = function (x, y) {
        return { x: x, y: y };
    };
    CartesianCoord.prototype.coordToData = function (coord) {
        return {
            x: this._xAxis.scale.invert(coord.x),
            y: this._yAxis.scale.invert(coord.y),
        };
    };
    CartesianCoord.prototype.getXScale = function () {
        return this._xAxis.scale;
    };
    CartesianCoord.prototype.getYScale = function () {
        return this._yAxis.scale;
    };
    CartesianCoord.prototype.recordToCoord = function (record, dataIndex, encode) {
        return this.dataToCoord({
            x: this._xAxis.isCategroy() ? dataIndex : encode.x,
            y: this._yAxis.isCategroy() ? dataIndex : encode.y,
        });
    };
    CartesianCoord.prototype.recordToPoint = function (record, dataIndex, encode) {
        return this.coordToPoint(this.recordToCoord(record, dataIndex, encode));
    };
    CartesianCoord.prototype.getCategoryAxis = function () {
        var isXCategory = this._xAxis.isCategroy();
        var isYCategory = this._yAxis.isCategroy();
        if (isXCategory) {
            return this._xAxis;
        }
        if (!isXCategory && isYCategory) {
            return this._yAxis;
        }
        return this._xAxis;
    };
    CartesianCoord.prototype.getValueAxis = function () {
        var isXCategory = this._xAxis.isCategroy();
        var isYCategory = this._yAxis.isCategroy();
        if (!isYCategory) {
            return this._yAxis;
        }
        if (!isXCategory && isYCategory) {
            return this._xAxis;
        }
        return this._yAxis;
    };
    CartesianCoord.prototype.getXAxis = function () {
        return this._xAxis;
    };
    CartesianCoord.prototype.getYAxis = function () {
        return this._yAxis;
    };
    CartesianCoord.prototype.valueToCoord = function (value, dataIndex) {
        var categoryAxis = this.getCategoryAxis();
        if (categoryAxis.type === 'xAxis') {
            return this.dataToCoord({
                x: dataIndex,
                y: value,
            });
        }
        return this.dataToCoord({
            x: value,
            y: dataIndex,
        });
    };
    return CartesianCoord;
}());
export default CartesianCoord;
